import React from 'react';
import LoanCalculator from './LoanCalculator';
// CSS is imported in index.calculator.js (the dedicated entry point) to avoid
// breaking non-Tailwind builds (client, creditor) that process this file via react-scripts.

const CalculatorPage = () => {
    return (
        <main className="min-h-screen bg-background py-8 sm:py-12 lg:py-16">
            <LoanCalculator />
        </main>
    );
};

export default CalculatorPage;
